import { type ReactNode } from 'react';
import AnnouncementBody from '@/app/modules/announcements/components/AnnouncementBody';

type AnnouncementContentProps = {
  titleId: string;
  title: string;
  senderLabel: string;
  body: string;
  children: ReactNode;
};

/** O comunicado como quem recebe o vê; quem criou vê o mesmo, só as ações mudam. */
const AnnouncementContent = ({ titleId, title, senderLabel, body, children }: AnnouncementContentProps) => (
  <div className="announcement-modal-content text-center">
    <h2 className="announcement-modal-title text-gray-900 mt-2 mb-1" id={titleId}>
      {title}
    </h2>
    <div className="announcement-modal-author text-muted mb-6">{senderLabel}</div>
    <div className="announcement-modal-body text-start mb-8">
      <AnnouncementBody body={body} />
    </div>
    {children}
  </div>
);

export default AnnouncementContent;
